import styled from 'styled-components'

import { makeStyles } from '@material-ui/core/styles'

export default makeStyles({
  password: {
    marginBottom: 0
  }
})

export const Container = styled.div`
  flex: 1 1 auto;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
`

export const Title = styled.div`
  font-weight: bold;
  margin-bottom: 15px;
  font-size: 1rem;
`
